module.exports = __webpack_public_path__ + "img/1537312646.f23bc0a0.jpg";